import Component from '@component';

export default class ClickRegisterLoyaltyProgram extends Component {
	onInit(el) {
		this.el = el;

		const userRegisterLoyalty = {};
		userRegisterLoyalty.event = 'loyalty_register';

		if (window.sessionStorage.getItem('userRegisterLoyalty') === 'yes') {
			window.sessionStorage.removeItem('userRegisterLoyalty');
			dataLayer.push(userRegisterLoyalty);
		}
	}

	onReady() {
		if (window.sessionStorage.getItem('userRegisterLoyalty') === 'yes') {
			window.sessionStorage.removeItem('userRegisterLoyalty');
		}
		this.el.addEventListener(
			'click',
			this.clickRegisterLoyaltyProgram.bind(this),
		);
	}

	clickRegisterLoyaltyProgram() {
		window.sessionStorage.setItem('userRegisterLoyalty', 'yes');
	}
}
